{
  "common": {
    "goBackA11y": "Go back",
    "contactSupport": "Contact Support",
    "legalDraft": "Draft for legal review"
  },
  "home": {
    "title": "Help & Support",
    "intro": "Find quick answers, stay safe, or reach the Opncue team.",
    "safeTitle": "Staying Safe",
    "safeBody": "Simple habits for low-pressure meetups.",
    "reportTitle": "Report a Problem",
    "reportBody": "Something broken, unsafe, or not working.",
    "feedbackTitle": "Feedback & Suggestions",
    "feedbackBody": "Ideas to help us make Opncue better.",
    "contactTitle": "Contact Support",
    "contactBody": "Message the Opncue team.",
    "guidelinesTitle": "Community Guidelines",
    "guidelinesBody": "How we keep Opncue respectful.",
    "privacyTitle": "Privacy & Account",
    "privacyBody": "Visibility, data, and your account.",
    "billingTitle": "Billing & Plus",
    "billingBody": "Subscription, purchases, and practice replies."
  },
  "contact": {
    "reportTitle": "Report a Problem",
    "safetyTitle": "Report a Safety Concern",
    "contactTitle": "Contact Support",
    "feedbackTitle": "Send Feedback",
    "reportPrompt": "What are you reporting?",
    "helpPrompt": "What do you need help with?",
    "categories": {
      "unsafe": "Unsafe behavior",
      "harassment": "Harassment",
      "fakeProfile": "Fake profile",
      "spam": "Spam",
      "bug": "Bug",
      "billingIssue": "Billing issue",
      "other": "Other",
      "safetyConcern": "Safety concern",
      "billingPlus": "Billing/Plus",
      "accountPrivacy": "Account/privacy",
      "feedback": "Feedback"
    },
    "sendError": "Couldn’t send your message",
    "sendErrorBody": "Please check your connection and try again in a moment.",
    "received": "Thanks. We received your message.",
    "reviewSoon": "We’ll review it as soon as we can.",
    "done": "Done",
    "message": "Message",
    "messagePlaceholder": "Write here...",
    "replyHeading": "Where should we reply?",
    "emailPlaceholder": "you@email.com",
    "urgent": "For urgent danger, contact local emergency services first.",
    "sending": "Sending…",
    "send": "Send"
  },
  "safe": {
    "title": "Staying Safe",
    "intro": "Opncue is built for low-pressure real-life connection. Your safety comes first.",
    "tips": "Tips",
    "items": {
      "public": "Meet in public places.",
      "instincts": "Trust your instincts.",
      "private": "Do not share your address, financial details, or private passwords.",
      "short": "Keep first meetups short and low-pressure.",
      "tell": "Tell someone you trust where you’re going if meeting someone new.",
      "block": "Use block or report if someone makes you uncomfortable.",
      "owe": "You never owe anyone a reply, meetup, or explanation."
    },
    "emergency": "If you are in immediate danger, contact local emergency services. Opncue support is not an emergency service.",
    "report": "Report a Safety Concern"
  },
  "feedback": {
    "title": "Feedback & Suggestions",
    "intro": "Help us make Opncue better.",
    "heading": "Share ideas about",
    "items": {
      "features": "Features you want",
      "screens": "Confusing screens",
      "wording": "Wording that feels off",
      "safety": "Safety improvements",
      "plus": "Plus features",
      "groups": "Group or chat improvements"
    },
    "note": "We read feedback, but we may not be able to reply to every message.",
    "send": "Send Feedback"
  },
  "report": {
    "title": "Report a Problem",
    "intro": "Tell us if something is broken, unsafe, misleading, or not working as expected.",
    "heading": "You can report",
    "items": {
      "bugs": "Bugs or crashes",
      "harassment": "Harassment or unsafe behavior",
      "profiles": "Fake or suspicious profiles",
      "spam": "Spam",
      "payment": "Payment or Plus issues",
      "features": "Problems with chats, visibility, or groups",
      "other": "Anything that feels wrong"
    },
    "private": "Reports are private. We’ll review and take action where needed.",
    "start": "Start Report"
  },
  "privacy": {
    "title": "Privacy & Account",
    "intro": "Control your visibility, data, and account.",
    "controls": "Where to find each control",
    "items": {
      "visibility": "Manage visibility: Profile → “Stay visible.”",
      "blocked": "Blocked people: block from a conversation's safety menu. To unblock, open that conversation in Inactive — or see everyone you've blocked under Profile, Blocked people.",
      "export": "Export progress data: Profile → Progress → Export progress (Opncue Plus).",
      "notifications": "Notification settings: Profile → Notifications."
    },
    "policies": "Policies",
    "privacyPolicy": "Privacy Policy",
    "terms": "Terms of Service",
    "deletion": "Deleting your account",
    "deleteWhere": "Profile → Account, at the very bottom.",
    "deleteKept": "Deletion removes or anonymises your information. Some records are kept where the law requires it or where they protect other people: safety reports and their evidence, and payment records.",
    "deleteStore": "A subscription bought through the App Store or Google Play is billed by Apple or Google, not by us. Deleting your account does not cancel it — cancel it in your Apple or Google account settings."
  },
  "topics": {
    "title": "Help Center",
    "intro": "Find quick answers about using Opncue.",
    "heading": "Topics",
    "items": {
      "profile": "Setting up your profile",
      "visible": "Becoming visible",
      "chats": "Starting chats",
      "groups": "Cue Circles and small groups",
      "goals": "Small Goals and progress tracking",
      "sharing": "Sharing progress",
      "practice": "Conversation Practice",
      "billing": "Plus and billing",
      "privacy": "Privacy and account settings"
    },
    "stillNeedHelp": "Still need help?"
  },
  "guidelines": {
    "title": "Community Guidelines",
    "intro": "Opncue is for respectful, low-pressure connection.",
    "please": "Please",
    "notAllowed": "Not allowed",
    "pleaseItems": {
      "kind": "Be kind and respectful.",
      "honest": "Be honest about who you are.",
      "boundaries": "Respect boundaries.",
      "noResponse": "Accept no response as a response.",
      "appropriate": "Keep conversations appropriate.",
      "public": "Meet in public places when meeting someone new.",
      "report": "Report behavior that feels unsafe."
    },
    "notAllowedItems": {
      "harassment": "Harassment, threats, hate, or intimidation",
      "sexual": "Sexual pressure or explicit messages to unwilling users",
      "spam": "Spam, scams, or fake profiles",
      "impersonation": "Impersonation",
      "private": "Sharing someone’s private information",
      "contact": "Repeated unwanted contact"
    },
    "never": "Never",
    "neverItems": {
      "underage": "Using Opncue if you are under 18 — it is for adults only",
      "minors": "Sexualising, grooming, or targeting a minor, or any content that exploits a child",
      "illegal": "Using Opncue to arrange, promote, or carry out anything illegal"
    },
    "neverConsequence": "We remove these accounts without warning. We may ask you to confirm your age, and we notify the authorities where we are legally required to or where it is needed to address a serious risk.",
    "consequence": "Breaking these guidelines can lead to suspension or account removal.",
    "report": "Report a Violation"
  },
  "billing": {
    "title": "Billing & Plus",
    "intro": "Manage your subscription, purchases, and practice replies.",
    "includes": "Plus includes",
    "rollover": "Included monthly practice replies reset each billing cycle and do not roll over. Purchased replies roll over.",
    "manage": "Manage plan",
    "contact": "Contact billing support"
  }
}
